<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="600px"
    overlay-opacity="0.8"
  >
    <v-card class="progress-card">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" class="mr-3">mdi-chart-line</v-icon>
        <span class="text-h6 font-weight-bold">Generando Reporte</span>
      </v-card-title>

      <v-card-text class="pb-6">
        <div class="text-center mb-4">
          <v-icon
            :class="['rotating-icon', { 'spin': isProcessing }]"
            color="primary"
            size="48"
          >
            mdi-cog
          </v-icon>
        </div>

        <!-- Barra de progreso principal -->
        <v-progress-linear
          v-model="progress"
          height="25"
          rounded
          color="primary"
          background-color="grey lighten-2"
          class="mb-4"
        >
          <template v-slot:default="{ value }">
            <strong class="white--text">{{ Math.ceil(value) }}%</strong>
          </template>
        </v-progress-linear>

        <!-- Información detallada -->
        <div class="info-section">
          <v-row class="mb-2">
            <v-col cols="12" class="text-center">
              <div class="info-item text-center">
                <v-icon small class="mr-2" color="success">mdi-database-check</v-icon>
                <span class="caption text--secondary">Registros procesados:</span>
                <div class="font-weight-bold primary--text">
                  {{ formatNumber(processedRecords) }} / {{ formatNumber(totalRecords) }}
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- Tiempo transcurrido -->
        <div class="text-center mt-4">
          <small class="text--secondary">
            <v-icon small class="mr-1">mdi-timer</v-icon>
            Tiempo transcurrido: {{ formatTime(elapsedTime) }}
          </small>
        </div>
      </v-card-text>

      <!-- Botón de cancelar (opcional) -->
      <v-card-actions v-if="allowCancel">
        <v-spacer></v-spacer>
        <v-btn
          text
          color="error"
          @click="$emit('cancel')"
          :disabled="progress > 95"
        >
          <v-icon left>mdi-close</v-icon>
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ProgressDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: 0
    },
    processedRecords: {
      type: Number,
      default: 0
    },
    totalRecords: {
      type: Number,
      default: 0
    },
    estimatedTimeLeft: {
      type: Number,
      default: 0
    },
    allowCancel: {
      type: Boolean,
      default: true
    },
    statusMessage: {
      type: String,
      default: ''
    },
    statusType: {
      type: String,
      default: 'info'
    }
  },
  data() {
    return {
      startTime: null,
      elapsedTime: 0,
      timer: null
    };
  },
  computed: {
    isProcessing() {
      return this.show && this.progress < 100;
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    }
  },
  methods: {
    startTimer() {
      this.startTime = Date.now();
      this.timer = setInterval(() => {
        this.elapsedTime = Date.now() - this.startTime;
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    formatNumber(num) {
      if (num === 0) return '0';
      return new Intl.NumberFormat('es-AR').format(num);
    },
    formatTime(milliseconds) {
      if (!milliseconds || milliseconds <= 0) return '--';

      const seconds = Math.floor(milliseconds / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);

      if (hours > 0) {
        return `${hours}h ${minutes % 60}m ${seconds % 60}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${seconds % 60}s`;
      } else {
        return `${seconds}s`;
      }
    }
  },
  beforeDestroy() {
    this.stopTimer();
  }
};
</script>

<style scoped>
.progress-card {
  border-radius: 12px !important;
}

.rotating-icon {
  transition: transform 0.3s ease;
}

.rotating-icon.spin {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.info-section {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e9ecef;
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info-item.text-center {
  align-items: center;
}

.v-progress-linear {
  border-radius: 12px !important;
}
</style>